import { SalesforceActions } from 'module/api/integrations/salesforce/types';
import { OutsideClickHandler } from 'module/ui/components/atoms/outside-click-handler';
import { Select } from '@rocketlane/ui';
import { FC, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { BlockList } from 'components/organisms/signal/detail/block-list/list';
import { StopClickEventPropagation } from 'components/organisms/signal/detail/stop-click-event-propagration';
import { useAutomationContext } from './automation-context';

// Hardcoded options mapped with SalesforceActions enum values
const HARDCODED_OPTIONS = [
  { value: SalesforceActions.Project, label: 'Project' },
  { value: SalesforceActions.Account, label: 'Account' },
];

// Map SalesforceActions to display labels
export const getActionLabel = (
  action: SalesforceActions | undefined,
): string => {
  if (!action) {
    return '';
  }
  const option = HARDCODED_OPTIONS.find((opt) => opt.value === action);

  return option?.label || action;
};

export const AutomationChoicesBlock: FC = () => {
  const [isAutomationChoicesCollapsed, setIsAutomationChoicesCollapsed] =
    useState(true);

  const { automationDetails, setAutomationDetails } = useAutomationContext();
  const { salesForceType, salesforceObject } = automationDetails || {};

  const { value } = salesforceObject || {};

  const [isLoading] = useState(false);

  const onOutsideClick = useCallback(() => {
    setIsAutomationChoicesCollapsed(true);
  }, []);

  const actionLabel = getActionLabel(salesForceType);

  return (
    <OutsideClickHandler onOutsideClick={onOutsideClick}>
      <BlockList.CollapsibleItem
        disabled={!value}
        collasped={isAutomationChoicesCollapsed}
        onCollapseChange={(collapsed) => {
          setIsAutomationChoicesCollapsed(collapsed);

          return true;
        }}
      >
        <BlockList.CollapsibleItem.Label data-required="true">
          <BlockList.CollapsibleItem.Label.Text>
            <FormattedMessage id="create" />
          </BlockList.CollapsibleItem.Label.Text>
        </BlockList.CollapsibleItem.Label>
        <BlockList.CollapsibleItem.Content className="body-short-01">
          {actionLabel ? (
            <div className="short-01">{actionLabel}</div>
          ) : (
            <div className="body-short-sb text-[var(--text-placeholder)]">
              Eg: Project
            </div>
          )}
        </BlockList.CollapsibleItem.Content>
        <BlockList.CollapsibleItem.ExpandedContent>
          <StopClickEventPropagation>
            <Select
              options={HARDCODED_OPTIONS}
              value={HARDCODED_OPTIONS.find(
                (option) => option.value === salesForceType,
              )}
              onChange={(selectedOption) => {
                if (selectedOption) {
                  setAutomationDetails({
                    salesForceType: selectedOption.value,
                  });
                }
              }}
              isLoading={isLoading}
              menuPortalTarget={document.body}
            />
          </StopClickEventPropagation>
        </BlockList.CollapsibleItem.ExpandedContent>
      </BlockList.CollapsibleItem>
    </OutsideClickHandler>
  );
};
